import {Injectable} from "@angular/core";
import {InitialCertApplicationReviewQuestionTranslator} from "../../application-reviewer/order-review/side-panel/checklist-panel/initial-cert-application-review-question-translator.service";
import {TransferApplicationReviewQuestionTranslator} from "../../application-reviewer/order-review/side-panel/checklist-panel/transfer-application-review-question-translator.service";
import {ProcessType} from "../../store/state/order.state";
import {QuestionTypeTranslator} from "../../application-reviewer/order-review/side-panel/checklist-panel/question-type-translator";

@Injectable()
export class QuestionTranslatorFactoryService {

	getTranslator(processType: ProcessType): QuestionTypeTranslator | null {
		switch (processType) {
			case ProcessType.TRANSFER:
				return new TransferApplicationReviewQuestionTranslator();
			case ProcessType.INITIAL_CERTIFICATION:
				return new InitialCertApplicationReviewQuestionTranslator();
			default:
				console.error("Unknown checklist question translator for process type: " + processType);
				return null;
		}
	}
}
